import { openNativePicker } from "../../date/openNativePicker";

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

/** Valeur stockée (ISO) vers la valeur attendue par un input date ou datetime-local. */
function toInputValue(value: string, withTime: boolean): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value.slice(0, withTime ? 16 : 10);

  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  if (!withTime) return day;
  return `${day}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function fromInputValue(value: string): string {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toISOString();
}

/**
 * Date ou date et heure d'un champ complémentaire.
 * Utilise le sélecteur natif, le même que les autres dates du formulaire.
 */
export default function CompInfoInputDate({
  value,
  onChange,
  className = "",
  showTimeSelect = false
}: {
  value: string,
  onChange: (data: string) => void,
  className?: string,
  showTimeSelect?: boolean
}) {
  return (
    <input
      type={showTimeSelect ? "datetime-local" : "date"}
      className={className}
      value={toInputValue(value, showTimeSelect)}
      onClick={openNativePicker}
      onChange={(event) => onChange(fromInputValue(event.target.value))}
    />
  );
}
